/* eslint-disable eqeqeq */
import config from '__api/config';
import { getInvCode } from '__api/dsbc/inv/getInvCode';
import { queryImageListByGroupId, ImageData, queryImageByCode } from '__api/pzpt';
import { getWxConfigData } from '__api/zqhd/GetWxConfigData';
import { Logger } from 'emrn-hybrid/Logger';
import { Passport } from 'emrn-hybrid/Passport';
import { invoke } from 'emrn-hybrid/invoke';
import { trackEvent } from 'emrn-hybrid/trackEvent';

/**
 * 分享报名页到站外方法配置
 */
export interface AppShareParams {
  /**
   * 分享渠道埋点id
   */
  trackCode?: string;
  /*分享*/
  groupCode: string;
}
export interface WxWebShareProps {
  /** 标题 */
  title: string;
  /** 描述 */
  desc: string;
  /** 页面链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致,默认 window.location.href */
  link?: string;
  /** 图片，确保图片域名可用，默认 https://marketing.dfcfs.com/activitytemplate/img/share/dfcf_logo.png */
  imgUrl?: string;
}
/**
 * 分享到站外
 * @param params 参数
 */
export const setWxShareInfo = async (params: WxWebShareProps) => {
  const { title, desc, imgUrl } = params ?? {};
  const shareImgUrl = imgUrl || 'https://marketing.dfcfs.com/activitytemplate/img/share/dfcf_logo.png';
  let url = window.location.href;
  const { data } = await getWxConfigData({ url: encodeURIComponent(url) });
  window.wx.config({
    debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
    appId: data?.appId, // 必填，公众号的唯一标识
    timestamp: data?.timestamp, // 必填，生成签名的时间戳
    nonceStr: data?.nonceStr, // 必填，生成签名的随机串
    signature: data?.signature, // 必填，签名
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的 JS 接口列表
  });

  window.wx.ready(() => {
    window.wx.updateAppMessageShareData({
      title, // 分享标题
      desc, // 分享描述
      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
      imgUrl: shareImgUrl, // 分享图标
      success: function () {
        console.log('设置成功');
        // 设置成功
      },
    });
    window.wx.updateTimelineShareData({
      title: title + ' ' + desc, // 分享标题
      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
      imgUrl: shareImgUrl, // 分享图标
      success: function () {
        console.log('设置成功');
        // 设置成功
      },
    });
  });
};
export const AppShare = async (params: AppShareParams, shareUrl?: string) => {
  let adList: ImageData[] | null;
  let title: string = '';
  let desc: string = '';
  let imgUrl: string = '';
  // TODO 分享链接 正式线
  let _shareUrl: string = 'https://zqhdplus.eastmoney.com/activity/zqhdweb/welfareOfficer/index.html';
  /*测试线*/
  // let _shareUrl: string = 'https://ceshi.securities.eastmoney.com:7438/activity/zqhdweb/welfareOfficer/index.html';
  const { trackCode, groupCode } = params;

  let { hasLogin: passportHasLogin, info: userInfo } = await Passport.getUserInfo();
  let uid: string = ''; //用户uid
  let invCode: string | undefined = ''; //用户邀请码
  if (passportHasLogin && userInfo && userInfo.uid) {
    uid = userInfo.uid;
    //缓存赛段信息
    //invCode = SessionCache.get(`ETFSimulationGameRn_invCode_${uid}`);
    if (!invCode || typeof invCode == 'undefined') {
      await getInvCode({ uid: uid }).then(
        (res: any) => {
          if (res.IsSuccess) {
            if (res?.Data?.invCode) {
              invCode = res?.Data?.invCode;
              // SessionCache.set(`ETFSimulationGameRn_invCode_${uid}`,invCode);
            }
          } else {
            Logger.info({ tag: '邀新活动', msg: '获取邀请码失败！' });
          }
        },
        () => {
          // Dialog(ApiHasErrorMessage);
        }
      );
    }
  }

  await queryImageByCode({ groupCode: 'g_cffe_welfare_officer' })
    .then(res => {
      if (res && res.code == 0) {
        // 根据groupCode匹配结果，作为当前的分享信息
        const shareInfo = res.data?.find(item => item.materialCode === groupCode);
        title = shareInfo?.title || '';
        desc = shareInfo?.subTitle || '';
        imgUrl = shareInfo?.imgUrl || '';
        if (shareInfo?.jumpWeb) {
          _shareUrl = shareInfo.jumpWeb;
        }
      } else {
        //Dialog(res.message || ApiHasErrorMessage);
      }
    })
    .catch(() => {});

  try {
    let url = shareUrl ? shareUrl : _shareUrl;
    console.log('分享链接', url);
    if (uid && invCode) {
      url = `${url}${url.indexOf('?') < 0 ? '?' : '&'}uid=${uid}&invUid=${uid}&invCode=${invCode}&from=invite`;
    }
    let request = {
      desc,
      title,
      image: imgUrl,
      filters: ['weixin', 'pengyouquan', 'qq', 'weibo'],
      url: `${url}`,
    };
    Logger.info({ tag: '邀新活动', msg: `分享即将开始，参数=${JSON.stringify(request)}` });
    const data: any = await invoke('Social', 'share', request);
    Logger.info({ tag: '邀新活动', msg: `分享完毕，选择的渠道：${data.selectedFilter}` });
    trackCode && trackEvent(trackCode);
    return !!data.selectedFilter && data.selectedFilter != 'cancel';
  } catch (error) {
    Logger.info({ tag: '邀新活动', msg: `分享出现错误，message=${(error as any).message}` });
    return false;
  }
};
